import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store';
import { Boutique } from '../types';
import API from '../lib/API';
import { setBoutiques } from '../slices/boutiquesSlice';

import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import NavBar, { tabs } from '../components/MainNavBar';

const BoutiquesView: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const boutiques = useSelector((state: RootState) => state.boutiques.boutiques);
    const token = useSelector((state: RootState) => state.status.token);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        const fetchBoutiques = async () => {
            try {
                setLoading(true);
                setError('');
                const response = await API.getBoutiques(token);
                dispatch(setBoutiques(response));
            } catch (error) {
                setError(error instanceof Error ? error.message : 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            fetchBoutiques();
        }
    }, [dispatch, token]);

    const handleRowClick = (boutiqueId: number) => {
        navigate(`/boutiques/${boutiqueId}`);
    };

    return (
        <>
            <NavBar tab={tabs.boutiques} />
            <Container className="mt-4">
                <h2 className="text-center mb-4">My Boutiques</h2>
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : error ? (
                    <Alert variant="danger">{error}</Alert>
                ) : (
                    <Table striped hover>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Status</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            {boutiques.map((boutique: Boutique) => (
                                <tr 
                                    key={boutique.boutiqueId}
                                    onClick={() => handleRowClick(boutique.boutiqueId)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>{boutique.name}</td>
                                    <td>{boutique.status}</td>
                                    <td>{new Date(boutique.created).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Container>
        </>
    );
};

export default BoutiquesView; 